import { render, staticRenderFns } from "./OfficeReportsToCheck.vue?vue&type=template&id=12246407&scoped=true&"
import script from "./OfficeReportsToCheck.vue?vue&type=script&lang=ts&"
export * from "./OfficeReportsToCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12246407",
  null
  
)

export default component.exports